import ControlTower from "./model/control-tower";
/**
 * Checks if a given ControlTower user is a MedicUser.
 * The user will be typed as MedicUser if that is the case
 *
 * @param user ControlTower user
 */
export function isMedicUser(user) {
  return user.class === "Medic";
}

/**
 * Checks if a given ControlTower user is a PatientUser.
 * The user will be typed as PatientUser if that is the case
 *
 * @param user ControlTower user
 */
export function isPatientUser(user) {
  return user.class === "Patient";
}
export default ControlTower;